import { render, staticRenderFns } from "./page-divisionView.vue?vue&type=template&id=7fc3efda&scoped=true&"
import script from "./page-divisionView.vue?vue&type=script&lang=js&"
export * from "./page-divisionView.vue?vue&type=script&lang=js&"
import style0 from "./page-divisionView.vue?vue&type=style&index=0&id=7fc3efda&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7fc3efda",
  null
  
)

export default component.exports